import { render, staticRenderFns } from "./ClientAddressList.vue?vue&type=template&id=64248e09&"
import script from "./ClientAddressList.vue?vue&type=script&lang=js&"
export * from "./ClientAddressList.vue?vue&type=script&lang=js&"
import style0 from "./ClientAddressList.vue?vue&type=style&index=0&id=64248e09&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports